import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'
import * as actions from 'redux/actions/addons.actions'
import NotificationToast from '_base/Notification'


function* getAddonsSaga() {
  try {
    const addons = yield call(agent.Addons.getAddons)
    yield put(actions.getAddonsSuccess(addons.data))
  } catch (error) {
    yield put(actions.getAddonsFailure(error))
  }
}

function* getOwnedAddonsSaga() {
  try {
    const body = yield call(agent.Addons.getOwnedAddons)
  
    yield put(actions.getOwnedAddonsSuccess(body.data))
  } catch (error) {
    yield put(actions.getOwnedAddonsFailure(error))
  }
}

function* removeAddonSaga({payload}) {
  try {
    const { id } = payload
    yield call(agent.Addons.removeAddon, id)
    yield put(actions.getOwnedAddons())
  } catch (error) {
    if (error.response.status === 422) {
      const errors = error.response?.body?.errors[0]?.detail || []
      errors.forEach(({error}) => {
        const { limit = '', plan = '' } = error
        NotificationToast('error', limit, plan)
      })
    } else if (error.response.status === 500) {
      NotificationToast('error', 'Sorry... We couldn\'t cancel Your addon. Try again later')
    }
  }
}

export default function* accountSagas() {
  yield all([
    takeLatest(actions.getAddons.type, getAddonsSaga),
    takeLatest(actions.getOwnedAddons.type, getOwnedAddonsSaga),
    takeLatest(actions.removeAddon.type, removeAddonSaga),
  ])
}
